import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { CollapsibleWebElement } from './CollapsibleWebElement';
export { CollapsibleWebElement };

/**
 * Retrieve an instance of [CollapsibleWebElement](../classes/CollapsibleWebElement.html).
 * @example
 * ```javascript
 * import { findCollapsible } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findCollapsible(driver, By.id('my-oj-c-collapsible'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findCollapsible(driver: DriverLike, by: By): Promise<CollapsibleWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type CollapsibleWebElement
  if (!(webEl instanceof CollapsibleWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'CollapsibleWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findCollapsible(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${CollapsibleWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-collapsible', CollapsibleWebElement);
